window.UserSettings = {
    hasLocalStorage: function() {
        if(this.hasLS === undefined) {
            // https://github.com/Modernizr/Modernizr/blob/master/feature-detects/storage/localstorage.js#L40
            var mod = 'modernizr';
            try {
                localStorage.setItem(mod, mod);
                localStorage.removeItem(mod);
                this.hasLs = true;
            } catch(e) {
                this.hasLs = false;
            }
        }

        return this.hasLs;
    },

    get: function(key, def) {
        if(!this.hasLocalStorage()) {
            return undefined;
        }

        var val = localStorage.getItem(key);
        if (val === null) {
            return def;
        }

        return JSON.parse(val);
    },

    set: function(key, value) {
        if(!this.hasLocalStorage()) {
            return undefined;
        }

        localStorage.setItem(key, JSON.stringify(value));
        return value;
    },

    remove: function(key) {
        if(!this.hasLocalStorage()) {
            return undefined;
        }
    },
}
